<template>
  <v-row>
    <template v-if="show">
      <v-col cols="12">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-4">

            <v-col cols="12">
              <label class="font-weight-bold text-uppercase">
                Emprendimiento:
              </label>
              <p class="font-weight-regular">
                {{ entrepreneurship.title }}
              </p>

              <label class="font-weight-bold text-uppercase">
                Categoria:
              </label>
              <p class="font-weight-regular">
                {{ entrepreneurship.type_postulations.name }}
              </p>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-btn
                large
                block
                color="primary"
                :to="{name: 'showConvocationFormOrganizer', params: { entrepreneurship_id: entrepreneurship.id }}"
                >
                Formulario de convocatoria
              </v-btn>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-btn
                large
                block
                color="primary"
                :to="{name: 'showTeamOrganizer', params: { entrepreneurship_id: entrepreneurship.id }}">
                Integrantes
              </v-btn>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-btn
                large
                block
                color="primary"
                :to="{name: 'showWindowOrganizer', params: { entrepreneurship_id: entrepreneurship.id }}">
                Stand
              </v-btn>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <notes
                :entrepreneurship_id="entrepreneurship.id" 
                :btn_block="true" 
              />
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-btn
                large
                block
                color="primary"
                :to="{name: 'showViewsOrganizer', params: { entrepreneurship_id: entrepreneurship_id }}">
                Visualizaciones
              </v-btn>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-btn
                large
                block
                color="primary"
                :to="{name: 'showLikesOrganizer', params: { entrepreneurship_id: entrepreneurship_id }}">
                Likes
              </v-btn>
            </v-col>
            
          </v-row>
        </v-sheet>
      </v-col>
    </template>

    <v-col cols="12" class="d-sm-flex pt-8">
      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-auto mt-2"
        depressed
        color="primary"
        :to="{ name: 'entrepreneurshipsOrganizer' }">
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>
    
    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import notes from '@/components/notes/notes.vue'

  export default {
    name: 'showEntrepreneurshipOrganizer',
    components: {
      notes
    },
    data: () => ({
      loading:true,
      edition_id:null,
      entrepreneurship_id:null,

      show:false,
      entrepreneurship:[],

      attrs: {
        boilerplate: false,
      },
    }),

    methods:{
      async getEntrepreneurshipOrganizer(){
        await axios.get('organizer/entrepreneurships/'+this.entrepreneurship_id).then(response =>{
          this.entrepreneurship = response.data.data.entrepreneurship
          this.loading=false
          this.show = true
        }).catch(error => {
          console.log(error)
        })
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.entrepreneurship_id = this.$route.params.entrepreneurship_id;
      this.getEntrepreneurshipOrganizer()
      },
  }
</script>